import {setStorage,getStorage,removeStorage} from './storageUtil'

const defaultUser = {
    token:'',
    userId: '',
    userName: '',
    depId:'',//部门
    depName:'',
    sex:'',
    roleId:'',//角色
    roleName:'',
    avatar:'',//头像
    authority: '',//权限
    menuAuth:'',//菜单权限
    menuShow:'1',//左侧菜单是否打开
    headShow:'1',//头部信息是否展开
    postLevelAuth: '',//职位级别
    messageCount: '',//未读消息数量
    isBusinessManager: '',//是否是部门经理
    chargeDep: '',//分管部门
};

const tokenKey = 'User-Token';

/**
 * 将用户信息存到本地
 * @param user
 */
function saveUser(user){
    let keys = Object.keys(defaultUser);
    keys.forEach(key=>{
        if(user[key] !== undefined){
            setStorage(key,user[key]);
        }
    })
}

/**
 * 获取用户信息
 */
function getUser(){
    let user = {};
    let keys = Object.keys(defaultUser);
    keys.forEach(key=>{
        user[key] = getStorage(key);
    });
    if(user.chargeDep === 'null')user.chargeDep = null;
    return user;

}

/**
 * 根据菜单名获取用户权限
 */
function isRole(routerPath){
    let user = {};
    let keys = Object.keys(defaultUser);
    keys.forEach(key=>{
        user[key] = getStorage(key);
    });
    let postLevelAuth = JSON.parse(user.postLevelAuth),
        roleLevel = '';
    for(let i in postLevelAuth) {
        if(routerPath === i) {
            roleLevel = postLevelAuth[i]
        }
    }
    return roleLevel
}
/**
 * 清楚本地用户信息
 */
function removeUser(){
    let keys = Object.keys(defaultUser);
    keys.forEach(key=>{
        removeStorage(key);
    })
}

function setToken(token){
    setStorage(tokenKey,token);
}
function getToken(){
    return getStorage(tokenKey);
}
function removeToken(){
    removeStorage(tokenKey);
}

window.getUser = getUser;
window.isRole = isRole;

export {
    saveUser,
    getUser,
    removeUser,
    setToken,
    getToken,
    removeToken,
    isRole
}
